
<div style="position: relative;">
  <!--(click)="openOfferInfoModal(event); $event.stopPropagation();" -->
<ion-grid [routerLink]="[event.service.slug]" style="padding:0px; margin:16px; border: 1px solid #dedede" class="clickable">
  <ion-row>


   <ion-col size-xs="12" size-md="8" size-xl="7" style="padding:0 15px 0 15px;" >

    <div class="small-img-wrapper" *ngIf="event?.activity?.avatarHref">
        <img style="border-radius: 100%; padding-right:0px; padding-top:0px;" [src]="event?.activity?.avatarHref | ppImage" />
      </div>

    <div style="width: 100%; display: table; margin-top:5px;">
    <div style="display: table-row">
        <!--div style="width: 50px; display: table-cell; vertical-align: middle;"> <ion-img [src]="( 'zeleni-kras' == real?.slug )?'/assets/icons/event-koline.svg':'/assets/icons/event.svg'"></ion-img> </div-->
        <div style="padding-left:0px">
          <p [style.color]="( 'zeleni-kras' == real?.slug )?'#bc313c':'#37B24D'" style="font-size:smaller; color: #37B24D; font-weight: bold; line-height: 0.8; color: #37B24D;">{{ event.start | date:'mediumDate': undefined: translateService?.currentLang }} ob {{ event.start | date:'H:mm' : undefined: translateService?.currentLang }}</p>
          <p 
  style="font-size: x-small;" 
  [ngStyle]="{
    'line-height': ((event.venueText || event.location?.address)?.length > 40) ? '1.7' : '0.8'
  }">
  {{ event.venueText ? event.venueText : event.location?.address }}
</p>
        </div>
    </div>
    </div>
      <!--div style="width: 100%; display: table;">
        <div style="display: table-row; padding:0px; margin: auto;">
            <div style="display: table-cell; width:40px; "><ion-img style="width: 100%;" [src]="'/assets/icons/event.svg'"></ion-img></div>
            <div style="display: table-cell;"> Right </div>
        </div>
      </div-->

      <!--ion-grid style="padding:0px; margin-top:5px;">
        <ion-row>
          
          <ion-col style="padding:0px;">
            <ion-img style="width: 40px;" [src]="'/assets/icons/event.svg'"></ion-img>
          </ion-col>


          <ion-col>
            <p style="font-size:smaller;">12. do 15. februar 2023</p>
            <p style="font-size:smaller;">med 16:00 in 22:00 uro</p>
          </ion-col>    

        </ion-row>
      </ion-grid-->  

    <div style="border-bottom:1px solid #efefef; padding-bottom:0px;">
      <h6 style="font-weight: bold; margin-top:4px;" class="event-name">{{ event?.name }}</h6>
      <p style="color:#494f56; font-size:x-small; line-height: 1.5em; height: 6em; overflow: hidden;">{{ event?.service.shortDescription }}</p>

      <ion-grid class="ion-no-padding">
        <ion-row >
          <ion-col size="7">
            <span style="color:#37B24D; font-size: smaller; font-weight:bold; display: inline-block; margin-bottom: 10px;">PRIJAVI SE</span>
            <img style="height:15px" *ngIf="event?.service?.difficulty" [src]="'/assets/icons/' + event?.service?.difficulty + '.gif'" />
          </ion-col>
          <ion-col size="5">
            <span [style.color]="( 'zeleni-kras' == real?.slug )?'#bc313c':'#37B24D'" *ngIf="event?.regularPrice1" style="color:#37B24D; font-size: smaller; font-weight:bold;" class="ion-float-right"><!--span *ngIf="service.minimalPrice.highestPrice!=service.minimalPrice.lowestPrice">{{ 'EVENT_CARD.FROM' | translate }} </span-->{{ event?.regularPrice1 | currency: 'EUR': 'symbol': '1.2-2' }}</span>
          </ion-col> 
        </ion-row>
      </ion-grid>  

      


    </div>

    <div style="color:#211e1e; font-size:x-small; margin-top:3px; margin-bottom:7px;">
      <span *ngIf="event?.service?.duration"><span *ngIf="this.currentUrl != '/vecerja-na-zajli' && this.currentUrl != '/vip-gourmet-klub'" >Delavnica</span><span *ngIf="this.currentUrl == '/vecerja-na-zajli'" >Doživetje</span><span *ngIf="this.currentUrl == '/vip-gourmet-klub'" >Dogodek</span> traja                                
  {{ event?.service?.duration / 3600 | number:'1.0-0' }}h</span><span *ngIf="event?.service?.duration % 3600">
  {{ (event?.service?.duration % 3600) / 60 | number:'1.0-0' }}min</span>
    </div>


    </ion-col>


    <ion-col size-xs="0"  size-md="4" size-lg="0" size-xl="5">
      <ion-img *ngIf="event?.activity?.avatarHref" style="width: 100%;" [src]="event?.activity?.avatarHref | ppImage"></ion-img>
      <img *ngIf="!event?.activity?.avatarHref" [src]="'https://dummyimage.com/800x800/333/FFF.png?text=' + event.name">
    </ion-col> 

  </ion-row>
</ion-grid>  






<!--ion-card (click)="openOfferInfoModal(service); $event.stopPropagation();" class="advertisment--saloon clickable" button="false" mode="ios">
  <div class="sticky-discount sticky-discount" style="background-color: #37B24D;"><ion-icon style="font-size:150%;" color="primary-contrast" name="calendar-outline"></ion-icon></div>
  <ion-img class="advertisment--saloon__img" [src]="'https://www.99.co/singapore/insider/wp-content/uploads/2017/02/valentine-day-dinner-ideas.jpg'"></ion-img>

  <ion-card-header   class="ion-no-padding">
    <ion-card-title class="advertisment--saloon__title">{{ service?.descriptionButtonText | ppTranslate:service.descriptionButtonTextTranslations:translateService.currentLang }}&nbsp;</ion-card-title>

    <ion-card-subtitle class="advertisment--saloon__subtitle">{{ service?.name }}</ion-card-subtitle>
    
    <ion-card-content class="advertisment--saloon__content">
      {{ service?.shortDescription | ppTranslate:service.shortDescriptionTranslations:translateService.currentLang }}&nbsp;
    </ion-card-content>

    <p>
      <a class="pp-link">VEČ O DOGODKU</a>
    </p>
  </ion-card-header>
</ion-card-->
</div>